/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {Database} from "../APIClient.jsx";
import DisplayIcon from "../components/Icons/DisplayIcon.jsx";
import ElementStatus from "../components/ElementStatus.jsx";
import DeploymentHistory from "../components/Container/DeploymentHistory.jsx";
import ContainerLogs from "../components/Container/ContainerLogs.jsx";
import DisplayStateHistory from "../components/DisplayStateHistory.jsx";
import Tabs from "../components/Tabs/Tabs.jsx";
import Tab from "../components/Tabs/Tab.jsx";
import ButtonComponent from "../components/BasicInputs/ButtonComponent.jsx";
import {motion} from "motion/react";
import BuildLogs from "../components/BuildLogs.jsx";
import {Socket} from "../Socket.js";
import {Subscription} from "../Subscription.js";
import ContainerCharts from "../components/Container/ContainerCharts.jsx";
import ServiceSettings from "../components/Services/ServiceSettings.jsx";
import ContainerPage from "./ContainerPage.jsx";

class ServicePage extends Component {
    constructor() {
        super();
        this.state = {
            serviceInfo: {},
            currentTab: 0,
            isLoaded: false,
            selectedBuild: ""

        }

        this.sub = new Subscription()
    }

    async fetchData() {
        let {serviceId} = this.props
        let service = await Database.table("Services", "app").simpleFilter("indexKey", serviceId)
        this.setState({serviceInfo: service?.recordset?.[0] ?? {}, isLoaded: true})

        this.sub.add(() => Database.table("Services", "app").onChange((change) => {
            let serviceInfo = this.state.serviceInfo
            serviceInfo = Socket.applyChange([serviceInfo], change)[0]

            this.setState({serviceInfo: serviceInfo})
        }), [{
            column: "serviceId",
            value: serviceId
        }], "liveContainerData")

    }

    componentDidMount() {
        this.fetchData()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.serviceId !== this.props.serviceId) {
            this.fetchData()
        }
    }

    openContainerURL() {
        let {serviceInfo} = this.state
        window.open("http://" + serviceInfo.domain, '_blank', 'noopener,noreferrer')
    }

    componentWillUnmount() {
        this.sub.unmount()
    }


    render() {
        let {serviceInfo, selectedBuild, isLoaded} = this.state

        if (!isLoaded) {
            return (<div>Loading service info. {this.props.serviceId}</div>)
        }

        return (
            <div>
                <div className={"overflow-hidden rounded-lg relative mb-4 mt-6 border border-1 "}>

                    <motion.img className="h-32 w-full object-cover lg:h-52 shadow-inner "
                                whileHover={{scale: 1.1, rotate: 1}}
                                transition={{
                                    type: "spring",
                                    stiffness: 450,
                                    damping: 15
                                }}
                                src={`/images/containerImages/${serviceInfo?.backgroundURL}.jpg`}
                                alt=""/>

                    <div className="px-4 py-3  bg-white/80 z-10 border-b absolute bottom-0 w-full ">
                        <div className="mx-auto flex items-center justify-between gap-x-8 lg:mx-0 ">
                            <div className="flex items-center gap-x-4">
                                <div
                                    className={"h-10 w-10 flex-none rounded-lg flex justify-center items-center text-stone-600"}>
                                    <DisplayIcon iconName={"Container"} className={"h-7 w-7"}/>


                                </div>

                                <h1>
                                    <div
                                        className=" text-xl font-semibold leading-4 text-gray-900">{serviceInfo.serviceName}</div>
                                    {/*<div className="text-xs leading-6 text-gray-500">{containerInfo.nodeIndexKey}</div>*/}

                                </h1>
                            </div>
                            <div className="flex items-center gap-x-4 sm:gap-x-6">
                                <ElementStatus name={"Services"} elementId={serviceInfo.indexKey}/>

                                <ButtonComponent
                                    text={"Open URL"}
                                    iconName={"PiArrowSquareOut"}
                                    className={"!bg-blue-500 text-white"}
                                    onClick={() => {
                                        return this.openContainerURL()

                                    }}/>


                            </div>
                        </div>
                    </div>
                </div>
                <Tabs activeKey={this.state.currentTab}
                      onSelect={(number) => this.setState({currentTab: number})} variant={'default'} isBox>
                    <Tab eventKey={0} title={"Übersicht"}>

                        <div className={"pt-4 flex flex-row gap-2"}>

                            <div className={"w-2/3"}>
                                {selectedBuild === "" ? (<>
                                    <ContainerLogs nodeId={serviceInfo.nodeIndexKey}
                                                   containerId={serviceInfo.indexKey}/>
                                </>) : (<>
                                    <BuildLogs buildId={selectedBuild}/>

                                </>)}


                            </div>
                            <div className={"w-1/3"}>
                                <DeploymentHistory selectedBuild={selectedBuild} imageId={serviceInfo.imageIndexKey}
                                                   onSelect={(newSelectedBuild) => {
                                                       this.setState({selectedBuild: newSelectedBuild})
                                                   }}
                                />

                            </div>
                        </div>

                    </Tab>
                    <Tab eventKey={2} title={"Status"}>
                        <DisplayStateHistory name={"Services"} elementId={serviceInfo.indexKey}/>

                    </Tab>
                    <Tab eventKey={3} title={"Einstellungen"}>

                        <ServiceSettings serviceId={serviceInfo.indexKey}/>

                    </Tab>
                    <Tab eventKey={4} title={"Resources"}>

                        <ContainerCharts nodeId={serviceInfo.nodeIndexKey} containerId={serviceInfo.indexKey}/>

                    </Tab>
                    <Tab eventKey={5} title={"Container"}>
                        <ContainerPage containerId={serviceInfo.containerId}/>
                    </Tab>
                </Tabs>


            </div>
        );
    }
}

ServicePage.propTypes = {};

ServicePage.defaultProps = {};


export default ServicePage;